"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentFragment = void 0;
const react_1 = __importDefault(require("react"));
const rich_content_element_1 = require("../rich-content-element");
const RichContentFragment = ({ path = 'root', children, bold, italic, color, fontSize }) => {
    if (!Array.isArray(children)) {
        return null;
    }
    return (react_1.default.createElement("span", null, children.map((fragment, key) => {
        const newPath = `${path}.${key}`;
        return (react_1.default.createElement(rich_content_element_1.RichContentElement, { bold: bold, italic: italic, path: newPath, key: newPath, color: color, fontSize: fontSize }, fragment));
    })));
};
exports.RichContentFragment = RichContentFragment;
